import React from "react"
import Navbar from "../components/NavBar"
import Timeline from "../components/Timeline"
import Footer from "../components/Footer"
import SEO from "../components/Seo"

export default function TimelineScreen() {
  return (
    <div>
      <SEO
        title="Timeline"
        description="Keep track of InfraDigital Foundation's current progress."
      />
      <Navbar />
      <Timeline />
      <Footer />
    </div>
  )
}
